import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useRef } from 'react';
import { useOption } from 'react-aria';
import { Box } from '../../Box/index.js';
import { Text } from '../../Text/Text.js';

var Option = function (_a) {
    var item = _a.item, state = _a.state;
    var ref = useRef(null);
    var _b = useOption({
        key: item.key,
    }, state, ref), optionProps = _b.optionProps, isDisabled = _b.isDisabled, isFocused = _b.isFocused;
    return (jsx("li", __assign({}, optionProps, { ref: ref }, { children: jsx(Box, __assign({ themeKey: "typeaheadOption", sx: __assign(__assign({}, (isFocused && {
                backgroundColor: "primary.5",
                color: "primary.100",
            })), (isDisabled && {
                backgroundColor: "black.5",
                color: "black.100",
                cursor: "default",
            })) }, { children: jsx(Text, { children: item.rendered }) })) })));
};

export { Option };
//# sourceMappingURL=Option.js.map
